import React from 'react';
import './Quote.css';

function Quote() {
  return (
    <div className="quote-body">
      <p>
        Mathematics is not about numbers, equations, computations
        <br />
        or algorithms: it is about understanding.-William Paul Thurston
      </p>
    </div>
  );
}

export default Quote;
